module.exports = "/images/click-the-city.png?a509d3ad336408ddf4960de6194a95ed";